module.exports = __webpack_public_path__ + "static/media/Cheque_Book_Request.e9868ae6.svg";